import React from 'react'

function SubmitButton(props) {
  return (
    <div className="col justify-content-center align-self-center">
      
        <button
          onClick={props.handleSubmit}
          className="btn btn-primary my-2 row"
        >
          
            <span
              className="col text-light"
              style={{
                fontSize: "16px",
                fontFamily: "Arial, sans-serif",
              }}
            >
              {" "}
              {props.submitBtn}
            </span>
          
        </button>
     
    </div>
  );
}

export default SubmitButton;